<template>
  <b-modal id="vendor-modal" title="Vendor" @shown="getVendor" @hidden="clearForm" hide-footer>
    <b-form id="vendor-form" @submit.prevent="submit">
      <b-form-group label="Vendor Name" label-class="form-control-label" label-for="name">
        <b-form-input v-model="vendor.name" required></b-form-input>
      </b-form-group>
      <b-form-group label="Vendor URL" label-class="form-control-label" label-for="url">
        <b-form-input type="url" v-model="vendor.url" required></b-form-input>
      </b-form-group>
      <b-row>
        <b-col md="6">
          <b-form-group label="Order" label-class="form-control-label" label-for="order">
            <b-form-input type="number" v-model="vendor.order" step="1" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Active" label-class="form-control-label" label-for="active">
            <base-switch class="mr-1" v-model="vendor.active" required></base-switch>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Logo" label-class="form-control-label" label-for="logo">
        <file-input @change="logoUpload"></file-input>
        <img :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + vendor.logo" class="w-100" v-if="vendor.logo">
      </b-form-group>
      <b-button block type="submit" variant="success">Submit</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import FileInput from '@/components/Inputs/FileInput';

export default {
  mixins: [errorsMixin],
  props: {
    slug: null,
    userRoute: null,
    enterprise_id: null,
  },
  components: {
    FileInput
  },
  data() {
    return {
      vendor: {
        name: '',
        url: '',
        logo: '',
        order: 0,
        active: true
      },
      file: [],
    }
  },
  methods: {
    async getVendor() {
      if (this.slug) {
        await axios.get(this.userRoute + "/vendors/" + this.slug)
        .then(response => {
          this.vendor = response.data;
        })
        .catch(error => {
          this.error(error);
        });
      }
    },
    submit() {
      if (this.slug) {
        this.updateVendor();
      } else {
        this.storeVendor();
      }
    },
    async storeVendor() {
      let formData = new FormData();
      let form = Object.keys(this.vendor);

      form.forEach(key => {
        formData.append(key, this.vendor[key]);
      });

      if (this.file.length > 0) {
        formData.append('file', this.file[0]);
      }

      if (this.enterprise_id) {
        formData.append('enterprise_id', this.enterprise_id);
      }

      await axios.post(this.userRoute + "/vendors", formData, {
        headers: {
          'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2)
        }
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getVendors');
          this.$bvModal.hide('vendor-modal');
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async updateVendor() {
      let formData = new FormData();
      
      formData.append('name', this.vendor.name);
      formData.append('url', this.vendor.url);
      formData.append('order', this.vendor.order);
      formData.append('active', this.vendor.active);
      formData.append('enterprise_id', this.vendor.enterprise_id);

      if (this.file.length > 0) {
        formData.append('file', this.file[0]);
      }

      formData.append('_method', 'PATCH');

      await axios.post(this.userRoute + "/vendors/" + this.slug, formData, {
        headers: {
          'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2)
        }
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getVendors');
          this.$bvModal.hide('vendor-modal');
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    clearForm() {
      this.$emit('clearSlug');
      this.vendor = {
        name: '',
        url: '',
        logo: '',
        order: 0,
        active: true
      }
    },
    logoUpload(logo) {
      this.file = logo;
    },
  }
};
</script>